/**
 * FastAPI Query List[T]용 직렬화: key=1&key=2 (dyeing_no_list[] 형태 금지)
 */
export const serializeFastApiQueryParams = (params) => {
    const parts = [];
    if (!params || typeof params !== 'object') return '';

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item === undefined || item === null || item === '') return;
                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`);
            });
            return;
        }
        if (value === '') return;
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    });

    return parts.join('&');
};
